import { useMutation } from "react-query"
import { ResponseType } from "../../Types/ServicesType/servicesType"
import usePrint from "../../hooks/usePrint";
import usePopup from "../../hooks/usePopup";
type ReportFileHookType = {
    apiFunction:(params:any)=>Promise<ResponseType<any>>;
    fileType?:"pdf" | "xls" | string
    responseFileKey?:string
}

const useRepotFile = ({apiFunction,fileType = "pdf",responseFileKey}:ReportFileHookType)=>{
    const {printPdf} = usePrint()
    const {showSnackbar} = usePopup()
  return useMutation(apiFunction,{
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        if(Boolean(responseFileKey)){
          const fileContent = result?.response[responseFileKey as string] as string
          printPdf(fileContent, "new-tab",fileType);
        }else{
          printPdf(result?.response as string, "new-tab",fileType);
        }
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 4000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 4000,
      });
    },
  })
}

export default useRepotFile